document.addEventListener('turbolinks:load', function() {
  const body = $('body');

  if (body.data('controller') !== 'calendar_imports' || body.data('action') !== 'new') return;
  pageBootstrap();
});

let pageBootstrap = () => {
  toggleBySelectValue();
};

let toggleBySelectValue = () => {
  let webinarIdSelect = $("#calendar_import_webinar_id");
  let importCalendarSubmit = $(".import-calendar-submit");

  webinarIdSelect.change(function(){
    let disabledFlag = webinarIdSelect.val() === "" || webinarIdSelect.val() === undefined

    importCalendarSubmit.prop("disabled", disabledFlag)
  });
};
